/**
 * start.ts
 * Startノードの定義
 * フローの開始点を表す固定ノード（削除不可）
 */
import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { StartNodeView } from '../views/StartNode';

/**
 * Startノードの定義
 * - パレットには表示しない（固定で配置済み）
 * - 実行時は開始のログを出力するのみ
 */
export const startDefinition: NodeDefinition<'start'> = {
  label: 'Start',
  showInPalette: false,     // 固定ノードなのでパレットに表示しない
  paletteColor: '',
  miniMapColor: '#22c55e',  // 緑色
  defaultData: { label: 'Start' },
  view: StartNodeView,
  run: (_node, _ctx, log) => {
    log('[Start] はじめる');
  },
  help: {
    title: [t('Start（はじめ）')],
    description: [
      t('プログラムはここから'),
      r('始', 'はじ'),
      t('まります。'),
      r('実行', 'じっこう'),
      t('すると、Start から'),
      r('順番', 'じゅんばん'),
      t('に'),
      r('進', 'すす'),
      t('んでいきます。'),
    ],
  },
};
